export { getSuspenseCache } from "./cache/getSuspenseCache.js";
export { InternalQueryReference, getWrappedPromise, unwrapQueryRef, updateWrappedQueryRef, wrapQueryRef, assertWrappedQueryRef, } from "./cache/QueryReference.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/internal/index.js
// module id = 316
// module chunks = 11